import $ from 'jquery';

$(document).on('click', (event) => {
  if (
    $('.notification').length &&
    !$(event.target).closest('.notifications').length
  ) {
    // cart presented but clicked outside
    $('.notification').slideUp();
  }
});
